/** Definições SVG que o CSS referencia por id.
 *
 * O protótipo tinha um `<svg>` escondido no topo do documento com estes filtros; ao portar
 * para componentes eu levei o CSS e esqueci o SVG. Resultado: `.pvc::after` pedia
 * `filter: url(#pvc-matte)`, o filtro não existia, e o cartão perdia a textura fosca do
 * PVC — ficava um retângulo de gradiente liso. Um filtro inexistente não dá erro em
 * lugar nenhum: simplesmente não acontece.
 *
 * Fica montado uma vez, na casca do app, fora do fluxo visual.
 */
export function Defs() {
  return (
    <svg width="0" height="0" aria-hidden="true" focusable="false" style={{ position: "absolute" }}>
      <defs>
        {/* Ruído fino e dessaturado: é o que faz o plástico do cartão parecer plástico
            e não uma área chapada de cor. */}
        <filter id="pvc-matte" x="0" y="0" width="100%" height="100%">
          <feTurbulence type="fractalNoise" baseFrequency=".9" numOctaves="2" stitchTiles="stitch" />
          <feColorMatrix type="saturate" values="0" />
        </filter>

        {/* A fibra do papel do registrador: mais grossa que a do PVC e bem mais fraca,
            para a grade impressa continuar sendo a textura dominante. */}
        <filter id="paper-grain" x="0" y="0" width="100%" height="100%">
          <feTurbulence type="fractalNoise" baseFrequency=".7" numOctaves="3" stitchTiles="stitch" />
          <feColorMatrix type="saturate" values="0" />
        </filter>
      </defs>
    </svg>
  );
}
